import React, {Component} from 'react';
import '../../style.css';
import {fetchPost,fetchPostFile} from "../../static/util/fetch";
import {
    Button,
    Card,
    message,
    PageHeader,
    Space,
    Table,
    Typography,
    Modal,
    Input,
    Form,
    Row, Col,
} from 'antd';
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import FileViewer from 'react-file-viewer';
const { Column, ColumnGroup } = Table;
const { Paragraph } = Typography;
const { TextArea } = Input;
class PatentTransferSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PatentTransfer:[],
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            string: "1.实用新型证书2.查新报告3.检测报告4.销售合同5.销售发票6.用户报告",
            fileStream:'',
            // preview_visible:false,
            loading:false,
            ifInsert_visible:false,
            edit_visible:false,//编辑弹窗状态
            add_visible:false,//添加弹窗状态
            delete_visible:false,//删除弹窗状态
            deleteId: 0,
            editId: 0,
            name:"",
            type:"",
            otherType:"",
            product:"",
            technology:"",
            sample:"",
            otherIn:"",
            permission:"",
            cooperate:"",
            invest:"",
            otherOut:"",
            prove:"",
            remark:"",
            newName:"",
            newType:"",
            newOtherType:"",
            newProduct:"",
            newTechnology:"",
            newSample:"",
            newOtherIn:"",
            newPermission:"",
            newCooperate:"",
            newInvest:"",
            newOtherOut:"",
            newProve:"",
            newRemark:"",
        }
       this.hideModal=this.hideModal.bind(this)
    }
    componentDidMount() {
        this.setState(()=>({
            loading:true
        }))
        fetchPost(global.constants.getPatentTransferSummaryGetD,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            PatentTransfer:res.data,
                            loading:false
                        }))
                    }
                    else{
                        if(res.code === -1){
                            this.setState(()=>({
                                loading:false,
                                ifInsert_visible:true
                            }))
                        }

                    }
                }
            )
    }
    handleExportClick(){
        fetchPost(global.constants.exportPatentTransferSummaryD,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                }
            )
    }
    download(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-8近三年科技成果转化汇总表.xlsx'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/2-8近三年科技成果转化汇总表.xlsx',
                            fileName: '近三年科技成果转化汇总表.xlsx'
                        }
                        fetchPostFile(global.constants.downloadFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=>{
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                            let filename = '2-8近三年科技成果转化汇总表.xlsx';//设置文件名称
                                            aElement.href = blobUrl;//设置a标签路径
                                            aElement.download = filename;
                                            aElement.click();
                                            window.URL.revokeObjectURL(blobUrl);
                                        }
                                    )
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
        // window.open(global.constants.downloadUrl + this.state.companyName + '/2-8近三年科技成果转化汇总表.xlsx')
    }
    hideModal(){
        this.setState(()=>({
            // preview_visible:false,
            ifInsert_visible:false,
            edit_visible:false,
            add_visible:false,
            delete_visible:false,
            preview_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-8近三年科技成果转化汇总表.xlsx'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                    let params = {
                        companyId:this.state.companyId,
                        projectId:'',
                        productId:'',
                        patentId:'',
                        remark:'',
                        url: '/create/'+this.state.companyName+'/近三年成果转化汇总表.pdf',
                        fileName: '近三年成果转化汇总表.pdf'
                    }
                    fetchPostFile(global.constants.previewFile,params)
                        .then(
                            res=>{
                                res.blob().then(
                                    blob=> {
                                        let blobUrl = window.URL.createObjectURL(blob);
                                        this.setState(()=>({
                                            fileStream:blobUrl,
                                            preview_visible:true,
                                        }))
                                    })
                            }
                        )}else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    AutoInsert(){
        fetchPost(global.constants.PatentTransferSummaryAutoD,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success('自动录入成功！').then()
                        this.setState(()=>({
                            ifInsert_visible:false,
                            loading:true
                        }))
                        fetchPost(global.constants.getPatentTransferSummaryGetD,{companyId: this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(() => ({
                                            PatentTransfer: res.data,
                                            loading: false
                                        }))
                                    }
                                }
                            )
                    }
                    else{
                        if(res.code === -1){
                            message.success(res.msg).then()
                            this.setState(()=>({
                                ifInsert_visible:false
                            }))
                        }

                    }
                }
            )
    }
    handleAdd(){
        this.setState(()=>({
            add_visible:true,
            name:"",
            type:"",
            otherType:"",
            product:"",
            technology:"",
            sample:"",
            otherIn:"",
            permission:"",
            cooperate:"",
            invest:"",
            otherOut:"",
            prove:"",
            remark:"",
        }))
    }
    addPatentTransfer(){
        if(this.state.name === ''||this.state.type === ''||this.state.product=== ''){
            message.info("请检查必填项是否填写完整").then()
        }else{
                fetchPost(global.constants.PatentTransferSummaryAddD, {
                    companyId:this.state.companyId,
                    name:this.state.name,
                    type: this.state.type,
                    otherType: this.state.otherType,
                    product: this.state.product,
                    technology:this.state.technology,
                    sample: this.state.sample,
                    otherIn: this.state.otherIn,
                    permission: this.state.permission,
                    cooperate: this.state.cooperate,
                    invest: this.state.invest,
                    otherOut:this.state.otherOut,
                    prove:this.state.prove,
                    remark:this.state.remark,
                    transfer:'',
                    applyNum:'',
                    authorizationNumber:''
                })
                    .then(
                        res => {
                            if (res.code === 200) {
                                message.success('添加成功！').then()
                                this.setState(() => ({
                                    add_visible: false,
                                    loading:true
                                }))
                                fetchPost(global.constants.getPatentTransferSummaryGetD,{companyId: this.state.companyId})
                                    .then(
                                        res => {
                                            if(res.code === 200) {
                                                this.setState(()=>({
                                                    PatentTransfer:res.data,
                                                    loading:false
                                                }))
                                            }
                                        }
                                    )
                            }
                        })
        }
    }
    handleUpload(e){
        const value = e.id;
        this.setState(()=>({
            editId:value,
        }))
        fetchPost(global.constants.PatentTransferSummaryGetOneD,{id:value})
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            newName:res.data.name,
                            newType:res.data.type,
                            newOtherType:res.data.otherType,
                            newProduct:res.data.product,
                            newTechnology:res.data.technology,
                            newSample:res.data.sample,
                            newOtherIn:res.data.otherIn,
                            newPermission:res.data.permission,
                            newCooperate:res.data.cooperate,
                            newInvest:res.data.invest,
                            newOtherOut:res.data.otherOut,
                            newProve:res.data.prove,
                            newRemark:res.data.remark,
                            edit_visible:true,
                        }))
                    }
                }
            )
    }
    uploadPatentTransfer(){
        let params = {
            id:this.state.editId,
            name:this.state.newName,
            type:this.state.newType,
            otherType:this.state.newOtherType,
            product:this.state.newProduct,
            technology:this.state.newTechnology,
            sample:this.state.newSample,
            otherIn:this.state.newOtherIn,
            permission:this.state.newPermission,
            cooperate:this.state.newCooperate,
            invest:this.state.newInvest,
            otherOut:this.state.newOtherOut,
            prove:this.state.newProve,
            remark:this.state.newRemark,
            transfer:'',
            applyNum:'',
            authorizationNumber:'',
        }
        fetchPost(global.constants.PatentTransferSummaryUpdateD, params)
            .then(
                res => {
                    if(res.code === 200){
                        message.success(res.msg).then()
                        this.setState(()=>({
                            edit_visible:false,
                            loading:true
                        }))
                        fetchPost(global.constants.getPatentTransferSummaryGetD,{companyId: this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            PatentTransfer:res.data,
                                            loading:false
                                        }))
                                    }
                                }
                            )
                    }
                    if(res.code === -1){
                        message.error(res.msg).then()
                    }
                }
            )
    }
    handleDelete(e){
        const value = e.id;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value,
        }))
    }
    deletePatentTransfer(){
        fetchPost(global.constants.PatentTransferSummaryDeleteD,{id:this.state.deleteId})
            .then(
                res => {
                    if(res.code === 200){
                        message.success('删除成功!').then();
                        this.setState(()=>({
                            delete_visible:false,
                            loading:true
                        }))
                        fetchPost(global.constants.getPatentTransferSummaryGetD,{companyId: this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            PatentTransfer:res.data,
                                            loading:false
                                        }))
                                    }
                                }
                            )
                    }
                    if(res.code === -1){
                        message.error(res.msg).then()
                        this.setState(()=>({
                            PatentTransfer:[],
                        }))
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="近三年成果转化汇总表"
                        subTitle="江苏及山东其他地区"
                        extra={[
                            <Button
                                type="primary"
                                onClick={this.handleAdd.bind(this)}
                            >
                                添加科技成果转化
                            </Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Button
                                type="primary"
                                onClick={this.handlePreviewClick.bind(this)}
                            >预览</Button>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style" >
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.PatentTransfer} bordered={true} loading={this.state.loading}>
                            <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                            <Column align="center" title={<p className="list-column-style">科技成果名称</p>} dataIndex="name" key="name" />
                            <ColumnGroup title={<p className="list-column-style">技术成果类别</p>}>
                                <Column align="center" title={<p className="list-column-style">知识产权</p>} dataIndex="type" key="type"/>
                                <Column align="center" title={<p className="list-column-style">其他技术成果</p>} dataIndex="otherType" key="otherType"/>
                            </ColumnGroup>
                            <ColumnGroup title={<p className="list-column-style">内部转化形式</p>}>
                                <Column align="center" title={<p className="list-column-style">产品/服务</p>} dataIndex="product" key="product"/>
                                <Column align="center" title={<p className="list-column-style">工艺</p>} dataIndex="technology" key="technology"/>
                                <Column align="center" title={<p className="list-column-style">样品/样机</p>} dataIndex="sample" key="sample"/>
                                <Column align="center" title={<p className="list-column-style">其他</p>} dataIndex="otherIn" key="otherIn"/>
                            </ColumnGroup>
                            <ColumnGroup title={<p className="list-column-style">外部转化形式</p>}>
                                <Column align="center" title={<p className="list-column-style">转让/许可</p>} dataIndex="permission" key="permission"/>
                                <Column align="center" title={<p className="list-column-style">合作</p>} dataIndex="cooperate" key="cooperate"/>
                                <Column align="center" title={<p className="list-column-style">作价投资</p>} dataIndex="invest" key="invest"/>
                                <Column align="center" title={<p className="list-column-style">其他</p>} dataIndex="otherOut" key="otherOut"/>
                            </ColumnGroup>
                            <Column
                                align="center"
                                dataIndex="prove"
                                title={<p className="list-column-style">证明材料</p>}
                                // render={(value, row, index) => {
                                //     if (index === 0) {
                                //         return{
                                //             props: {rowSpan:10},
                                //         }
                                //     }else{
                                //         return{
                                //             props: {rowSpan:0},
                                //         }
                                //     }
                                // }}
                                key="prove"/>
                            <Column
                                align="center"
                                title={<p className="list-column-style">备注</p>}
                                dataIndex="remark"
                                key="remark"/>
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle" direction="vertical">
                                        <Button
                                            type="primary"
                                            icon={<EditOutlined />}
                                            onClick={this.handleUpload.bind(this,record)}
                                        >编辑</Button>
                                        <Button
                                            type="primary"
                                            icon={<DeleteOutlined />}
                                            onClick={this.handleDelete.bind(this,record)}
                                        >删除</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                    <Typography>
                        <Paragraph>
                        <pre>注：科技成果是指通过科学研究与技术开发所产生的具有实用价值的成果（专利、版权、集成电路布图设计等）。
                            科技成果转化形式包括：自行投资实施转化；向他人转让该技术成果；许可他人使用该科技成果；以该科技成果作为合作条件，
                            与他人共同实施转化；以该科技成果作价投资、折算股份或者出资比例；以及其他协商确定的方式。
                            科技成果转化证明材料包括知识产权授权证书或申请受理通知书、成果说明等；内部转化可从生产批文、
                            新产品或新技术推广应用证明、产品质量检验报告等方面提供材料；外部转化可从技术合同、合作协议等方面提供材料。</pre>
                        </Paragraph>
                    </Typography>
                </Space>
                <Modal
                    visible={this.state.ifInsert_visible}
                    title={'提示'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            手动录入
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.AutoInsert.bind(this)}>
                            自动录入
                        </Button>,
                    ]}
                >
                    该公司还没有录入相关信息，请选择数据录入方式？
                </Modal>
                <Modal
                    visible={this.state.add_visible}
                    title={'添加'}
                    onOk={this.addPatentTransfer.bind(this)}
                    onCancel={this.hideModal}
                    width={"50%"}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.addPatentTransfer.bind(this)}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="科技成果名称" name="name" rules={[{ required: true, message: '请输入科技成果名称!' }]}>
                            <Input onChange={(e) => this.nameChange(e.target.value)}/></Form.Item>
                    </Form>
                    <Form>
                        <div className={'modal-title1'}>技术成果类别</div>
                        <Form.Item label="知识产权" name="type" rules={[{ required: true, message: '请输入知识产权!' }]}>
                            <Input onChange={(e) => this.typeChange(e.target.value)}/></Form.Item>
                        <Form.Item label="其他技术成果" name="otherType" >
                            <Input onChange={(e) => this.otherTypeChange(e.target.value)}/></Form.Item>
                    </Form>
                    <div>
                        <Row gutter={32}>
                            <Col span={12}>
                                <Form>
                                    <div className={'modal-title1'}>内部转化形式</div>
                                    <Form.Item label="产品/服务" name="product" rules={[{ required: true, message: '请输入产品/服务!' }]}>
                                        <Input onChange={(e) => this.productChange(e.target.value)}/></Form.Item>
                                    <Form.Item label="工艺" name="technology" >
                                        <Input onChange={(e) => this.technologyChange(e.target.value)}/></Form.Item>
                                    <Form.Item label="样品/样机" name="sample" >
                                        <Input onChange={(e) => this.sampleChange(e.target.value)}/></Form.Item>
                                    <Form.Item label="其他" name="otherIn" >
                                        <Input onChange={(e) => this.otherInChange(e.target.value)}/></Form.Item>
                                </Form>
                            </Col>
                            <Col span={12}>
                                <Form>
                                    <div className={'modal-title1'}>外部转化形式</div>
                                    <Form.Item label="转让/许可" name="permission" >
                                        <Input onChange={(e) => this.permissionChange(e.target.value)}/></Form.Item>
                                    <Form.Item label="合作" name="cooperate" >
                                        <Input onChange={(e) => this.cooperateChange(e.target.value)}/></Form.Item>
                                    <Form.Item label="作价投资" name="invest" >
                                        <Input onChange={(e) => this.investChange(e.target.value)}/></Form.Item>
                                    <Form.Item label="其他" name="otherOut" >
                                        <Input onChange={(e) => this.otherOutChange(e.target.value)}/></Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                    <Form>
                        <Form.Item label="证明材料" name="prove" >
                            <TextArea autoSize={{ minRows: 2, maxRows: 3 }}
                                      onChange={(e) => this.proveChange(e.target.value)}/></Form.Item>
                        <Form.Item label="备注" name="remark" >
                            <Input onChange={(e) => this.remarkChange(e.target.value)}/></Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.edit_visible}
                    title={'编辑'}
                    onOk={this.uploadPatentTransfer.bind(this)}
                    onCancel={this.hideModal}
                    width={"50%"}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.uploadPatentTransfer.bind(this)}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="科技成果名称" name="newName">
                            <Input defaultValue={this.state.newName}  onChange={(e) => this.newNameChange(e.target.value)}/></Form.Item>
                    </Form>
                    <Form>
                        <div className={'modal-title1'}>技术成果类别</div>
                        <Form.Item label="知识产权" name="newType">
                            <Input defaultValue={this.state.newType} onChange={(e) => this.newTypeChange(e.target.value)}/></Form.Item>
                        <Form.Item label="其他技术成果" name="newOtherType" >
                            <Input defaultValue={this.state.newOtherType} onChange={(e) => this.newOtherTypeChange(e.target.value)}/></Form.Item>
                    </Form>
                    <div>
                    <Row gutter={32}>
                        <Col span={12}>
                            <Form>
                                <div className={'modal-title1'}>内部转化形式</div>
                                <Form.Item label="产品/服务" name="newProduct" rules={[{ required: true, message: '请输入产品/服务!' }]}>
                                    <Input defaultValue={this.state.newProduct} onChange={(e) => this.newProductChange(e.target.value)}/></Form.Item>
                                <Form.Item label="工艺" name="newTechnology" >
                                    <Input defaultValue={this.state.newTechnology} onChange={(e) => this.newTechnologyChange(e.target.value)}/></Form.Item>
                                <Form.Item label="样品/样机" name="newSample" >
                                    <Input defaultValue={this.state.newSample} onChange={(e) => this.newSampleChange(e.target.value)}/></Form.Item>
                                <Form.Item label="其他" name="newOtherIn" >
                                    <Input defaultValue={this.state.newOtherIn} onChange={(e) => this.newOtherInChange(e.target.value)}/></Form.Item>
                            </Form>
                        </Col>
                        <Col span={12}>
                            <Form>
                                <div className={'modal-title1'}>外部转化形式</div>
                                <Form.Item label="转让/许可" name="newPermission" >
                                    <Input defaultValue={this.state.newPermission} onChange={(e) => this.newPermissionChange(e.target.value)}/></Form.Item>
                                <Form.Item label="合作" name="newCooperate" >
                                    <Input defaultValue={this.state.newCooperate} onChange={(e) => this.newCooperateChange(e.target.value)}/></Form.Item>
                                <Form.Item label="作价投资" name="newInvest" >
                                    <Input defaultValue={this.state.newInvest} onChange={(e) => this.newInvestChange(e.target.value)}/></Form.Item>
                                <Form.Item label="其他" name="newOtherOut" >
                                    <Input defaultValue={this.state.newOtherOut} onChange={(e) => this.newOtherOutChange(e.target.value)}/></Form.Item>
                            </Form>
                        </Col>
                    </Row>
                    </div>
                    <Form>
                        <Form.Item label="证明材料" name="newProve" >
                            <TextArea autoSize={{ minRows: 2, maxRows: 3 }}
                                      defaultValue={this.state.newProve}
                                      onChange={(e) => this.newProveChange(e.target.value)}/></Form.Item>
                        <Form.Item label="备注" name="newRemark" >
                            <Input defaultValue={this.state.newRemark} onChange={(e) => this.newRemarkChange(e.target.value)}/></Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.delete_visible}
                    title={'温馨提示'}
                    onOk={this.deletePatentTransfer.bind(this)}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.deletePatentTransfer.bind(this)}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定删除该条信息吗？</div>
                </Modal>
                <Modal
                    visible={this.state.preview_visible}
                    title={'预览'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'50%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                            下载
                        </Button>,
                    ]}
                >
                    <FileViewer fileType='pdf'
                                filePath={this.state.fileStream}
                                onError={this.onError}
                    />
                </Modal>
            </div>
        )
    }
    nameChange(e){
        this.setState({
            name:e
        })
    }
    typeChange(e){
        this.setState({
            type:e
        })
    }
    otherTypeChange(e){
        this.setState({
            otherType:e
        })
    }
    productChange(e){
        this.setState({
            product:e
        })
    }
    technologyChange(e){
        this.setState({
            technology:e
        })
    }
    sampleChange(e){
        this.setState({
            sample:e
        })
    }
    otherInChange(e){
        this.setState({
            otherIn:e
        })
    }
    permissionChange(e){
        this.setState({
            permission:e
        })
    }
    cooperateChange(e){
        this.setState({
            cooperate:e
        })
    }
    investChange(e){
        this.setState({
            invest:e
        })
    }
    otherOutChange(e){
        this.setState({
            otherOut:e
        })
    }
    proveChange(e){
        this.setState({
            prove:e
        })
    }
    remarkChange(e){
        this.setState({
            remark:e
        })
    }
    newNameChange(e){
        this.setState({
            newName:e
        })
    }
    newTypeChange(e){
        this.setState({
            newType:e
        })
    }
    newOtherTypeChange(e){
        this.setState({
            newOtherType:e
        })
    }
    newProductChange(e){
        this.setState({
            newProduct:e
        })
    }
    newTechnologyChange(e){
        this.setState({
            newTechnology:e
        })
    }
    newSampleChange(e){
        this.setState({
            newSample:e
        })
    }
    newOtherInChange(e){
        this.setState({
            newOtherIn:e
        })
    }
    newPermissionChange(e){
        this.setState({
            newPermission:e
        })
    }
    newCooperateChange(e){
        this.setState({
            newCooperate:e
        })
    }
    newInvestChange(e){
        this.setState({
            newInvest:e
        })
    }
    newOtherOutChange(e){
        this.setState({
            newOtherOut:e
        })
    }
    newProveChange(e){
        this.setState({
            newProve:e
        })
    }
    newRemarkChange(e){
        this.setState({
            newRemark:e
        })
    }
}

export default PatentTransferSummary;